"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSuggestionFromLocalStorage = exports.saveSuggestionToLocalStorage = exports.getInitialRecentSearches = exports.setSavedSuggestions = void 0;
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var savedSuggestionsKey = 'CVSavedSuggestions';
function setSavedSuggestions(recentSearches) {
    try {
        localStorage.setItem(savedSuggestionsKey, JSON.stringify(recentSearches));
    }
    catch (e) {
        console.error('Failed to save suggestion to local storage', e);
    }
}
exports.setSavedSuggestions = setSavedSuggestions;
function getSuggestionsFromLocalStorage() {
    var _a;
    return JSON.parse((_a = localStorage.getItem(savedSuggestionsKey)) !== null && _a !== void 0 ? _a : '[]');
}
function getRecentSearches() {
    var savedSuggestions = getSuggestionsFromLocalStorage();
    return savedSuggestions.map(function (recentSearch) { return (__assign(__assign({}, recentSearch), { searchType: constants_1.SearchType.RecentSearch })); });
}
function removeLegacySearches(savedSearches) {
    var filteredSearches = savedSearches.filter(function (currentItem) { return !currentItem.hasOwnProperty('legacyFilters'); });
    if (savedSearches.length !== filteredSearches.length) {
        console.error('Homepage legacyFilters removed'); // For visibility in datadog
    }
    setSavedSuggestions(filteredSearches);
    return filteredSearches;
}
function getInitialRecentSearches() {
    var savedSuggestions = getSuggestionsFromLocalStorage();
    return removeLegacySearches(savedSuggestions).map(function (recentSearch) { return (__assign(__assign({}, recentSearch), { searchType: constants_1.SearchType.RecentSearch })); });
}
exports.getInitialRecentSearches = getInitialRecentSearches;
function isSearchSuggestion(v) {
    return ('buildKey' in v &&
        'filters' in v &&
        'searchType' in v &&
        v.searchType === constants_1.SearchType.TextSearch);
}
function saveSuggestionToLocalStorage(itemToSave) {
    var recentSearches = getRecentSearches();
    if (!isSearchSuggestion(itemToSave)) {
        return recentSearches;
    }
    var formattedItemToSave = {
        buildKey: itemToSave.buildKey,
        filters: itemToSave.filters,
        highlightedText: itemToSave.highlightedText,
        isSavedSuggestion: true,
        text: itemToSave.text
    };
    var existsInLocalStorage = recentSearches.some(function (suggestion) {
        return suggestion.text === formattedItemToSave.text;
    });
    if (!existsInLocalStorage) {
        recentSearches.unshift(__assign(__assign({}, formattedItemToSave), { searchType: constants_1.SearchType.RecentSearch }));
        setSavedSuggestions(recentSearches);
    }
    return getRecentSearches();
}
exports.saveSuggestionToLocalStorage = saveSuggestionToLocalStorage;
function removeSuggestionFromLocalStorage(removedSuggestionText, inputValue) {
    if (inputValue === void 0) { inputValue = ''; }
    var updatedRecentSearches = getRecentSearches().filter(function (suggestion) {
        return (suggestion.text.toLowerCase() !== removedSuggestionText.toLowerCase());
    });
    setSavedSuggestions(updatedRecentSearches);
    return updatedRecentSearches.map(function (_a) {
        var text = _a.text, rest = __rest(_a, ["text"]);
        return (__assign(__assign({}, rest), { searchType: constants_1.SearchType.RecentSearch, text: text, highlightedText: (0, utils_1.highlightText)(text, inputValue) }));
    });
}
exports.removeSuggestionFromLocalStorage = removeSuggestionFromLocalStorage;
//# sourceMappingURL=suggestions.js.map